import React, { Component } from 'react';
import { Select} from 'antd';
import { connect } from 'react-redux'
import { setLanguage } from '../actions/languageAction'

import app_config from '../config/config.json';

const locales = app_config.Locales;
const Option = Select.Option;

class LangSwitcher extends Component {
    changeLocale = (e) => {
        console.log('click', e);
        this.props.changeLanguageAction(e.key);
      };

    render() { 
      return (
        <div>
            <Select labelInValue defaultValue={{ key: this.props.language }} style={{ width: 120 }} onChange={this.changeLocale}>
             {locales.map( (value) =>
                  <Option key={value.Code}>{value.Name}</Option>
                 )}  
            </Select>
        </div>
      );
    }
  }
  
  const mapStateToProps = store => {
     return {
      language: store.language.code,
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      changeLanguageAction: code => dispatch(setLanguage(code))
    }
  }
  export default connect(mapStateToProps, mapDispatchToProps)(LangSwitcher)